module.exports = __webpack_public_path__ + "static/media/80Hou.1a99b0cb.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/80Hou.png
// module id = 1692
// module chunks = 0 1